import { Injectable } from '@angular/core'
import { LoaderService } from './loader.service'
import {
  GetOnboardingGQL,
  VerifyOtpGQL,
  GenerateOtpGQL,
  VerifyOtpInput,
  CreateOnboardingGQL,
  OnboardingUpdateInput,
  UpdateOnboardingGQL,
  OnboardingCreateInput,
} from '../gql/generated'
import { tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor(
    private loaderService: LoaderService,
    private getOnboardingGQL: GetOnboardingGQL,
    private createOnboardingGQL: CreateOnboardingGQL,
    private updateOnboardingGQL: UpdateOnboardingGQL,
    private generateOtpGQL: GenerateOtpGQL,
    private verifyOtpGQL: VerifyOtpGQL
  ) {}

  getOnboarding(customerId: string) {
    return this.loaderService.withLoader(
      () =>
        this.getOnboardingGQL
          .fetch(
            { customerId },
            {
              context: {
                headers: {
                  'vendure-token': 'K7',
                },
              },
              fetchPolicy: 'network-only'
            }
          )
          .pipe(tap((response) => response.data?.getOnboarding)),
      OnboardingService.name
    )
  }

  createOnboarding(input: OnboardingCreateInput) {
    return this.loaderService.withLoader(
      () =>
        this.createOnboardingGQL.mutate(
          { input },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            }
          }
        ).pipe(
          tap({
            next: (response) => {
              console.log(response)
            },
          })
        ),
      OnboardingService.name
    )
  }

  updateOnboarding(input: OnboardingUpdateInput) {
    return this.loaderService.withLoader(
      () =>
        this.updateOnboardingGQL.mutate(
          { input },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            }
          }
        ).pipe(
          tap({
            next: (response) => {
              console.log(response)
            },
          })
        ),
      OnboardingService.name
    )
  }

  generateOtp(customerId: string) {
    return this.loaderService.withLoader(
      () =>
        this.generateOtpGQL.mutate(
          { customerId },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            }
          }
        ).pipe(
          tap({
            next: (response) => {
              console.log(response)
            },
          })
        ),
      OnboardingService.name
    )
  }

  verifyOtp(input: VerifyOtpInput) {
    return this.loaderService.withLoader(
      () =>
        this.verifyOtpGQL.mutate(
          { input },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            }
          }
        ).pipe(
          tap({
            next: (response) => {
              console.log(response)
            },
          })
        ),
      OnboardingService.name
    )
  }
}
